up.$compiler('[quick-view-modal-link]', ($element) => {
  let html = $element.html()
  $element.on('click', function () {
    up.layer.open({ fragment: html, target: '.quick-view-modal-content' })

    return false
  })
})
